import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'

export interface RuleChip {
  id: string
  label: string
  description?: string
  stale?: boolean
  thumbnail?: ReactNode
}

export const RuleChips: React.FC<{
  chips: RuleChip[]
  emptyCopy: string
  canEdit: boolean
  onRemove: (id: string) => void
}> = ({ chips, emptyCopy, canEdit, onRemove }) => {
  const { t } = useTranslation()
  if (chips.length === 0)
    return <p className="text-xs text-neutral-500">{emptyCopy}</p>
  return (
    <ul className="m-0 flex list-none flex-wrap gap-2 p-0">
      {chips.map((chip) => (
        <li key={chip.id}>
          <Base.Chip
            description={chip.description}
            leading={chip.thumbnail}
            tone={chip.stale ? 'warning' : 'neutral'}
            onRemove={canEdit ? () => onRemove(chip.id) : undefined}
            removeLabel={t('non_returnable.remove', { name: chip.label })}
          >
            {chip.label}
          </Base.Chip>
        </li>
      ))}
    </ul>
  )
}
